/* eslint-disable no-param-reassign */
import {
  call, put, select,
} from 'redux-saga/effects';
import Sonda from '@bit/gerenciatd.utils.front-sonda';
import { getProductByAlias } from '@bit/gerenciatd.adabyron-cloud.orion';
import { actions as fichasActions } from '../reducers/fichas';
import { normalizeSoluciones } from './normalizers/soluciones';

const contextStore = state => state.context.data;

/**
   * Obtiene una fichas por su alias
   * @returns {undefined}
   */
export function* setFicha({ payload }) {
  const context = yield select(contextStore);
  const { alias } = payload;
  const sonda = new Sonda({
    processName: 'setFicha',
    context,
    filePath: 'sagas/fichas',
  });

  try {
    const dataToAdabyron = {
      alias,
    }
    const argsToAdabyron = [dataToAdabyron, context];
    let response = '';
    try {
      response = yield call(getProductByAlias, ...argsToAdabyron);
    } catch (error) {
      sonda.severalMessage({ error, info: 'Fallo del servicio' });
      yield put(fichasActions.getFichasFailure('Fallo del servicio'));
      return null;
    }

    let responseNormalized = null;

    responseNormalized = normalizeSoluciones(response);

    if (responseNormalized && Array.isArray(responseNormalized)) {
      yield put(fichasActions.getFichasSuccess(responseNormalized));
    } else {
      sonda.severalMessage({ info: 'Estructura incorrecta tras normalizar la respuesta' });
      yield put(fichasActions.getFichasFailure('Estructura incorrecta tras normalizar la respuesta'));
      return null;
    }
  } catch (error) {
    sonda.severalMessage({ error });

    yield put(fichasActions.getFichasFailure(error.message));
    return null;
  }
}
